import type { ConfidenceThresholdsResponse } from '../api';

interface ThresholdSlidersProps {
  value: ConfidenceThresholdsResponse;
  onChange: (next: ConfidenceThresholdsResponse) => void;
  disabled?: boolean;
}

interface SliderConfig {
  key: keyof ConfidenceThresholdsResponse;
  label: string;
  help: string;
  min: number;
  max: number;
  step: number;
}

const SLIDERS: ReadonlyArray<SliderConfig> = [
  {
    key: 'fieldWarning',
    label: 'Aviso por campo',
    help: 'Score por debajo del cual un campo se marca como aviso.',
    min: 0,
    max: 1,
    step: 0.01,
  },
  {
    key: 'fieldCritical',
    label: 'Crítico por campo',
    help: 'Score por debajo del cual un campo crítico fuerza la revisión.',
    min: 0,
    max: 1,
    step: 0.01,
  },
  {
    key: 'documentReviewRatio',
    label: 'Ratio de revisión',
    help: 'Proporción de campos requeridos en aviso para enviar el documento a revisión.',
    min: 0,
    max: 1,
    step: 0.01,
  },
];

/** Sliders for the three "review" thresholds. `documentRejectGlobalScore` is read-only here (admin-only). */
export function ThresholdSliders({
  value,
  onChange,
  disabled = false,
}: ThresholdSlidersProps): JSX.Element {
  return (
    <div className="space-y-4">
      {SLIDERS.map((slider) => {
        const current = value[slider.key];
        return (
          <div key={slider.key}>
            <div className="flex items-baseline justify-between">
              <label htmlFor={`slider-${slider.key}`} className="label mb-0">
                {slider.label}
              </label>
              <span className="text-sm tabular-nums text-slate-700">{current.toFixed(2)}</span>
            </div>
            <input
              id={`slider-${slider.key}`}
              type="range"
              min={slider.min}
              max={slider.max}
              step={slider.step}
              value={current}
              disabled={disabled}
              onChange={(event) =>
                onChange({ ...value, [slider.key]: Number(event.target.value) })
              }
              className="mt-2 w-full accent-primary"
            />
            <p className="mt-1 text-xs text-slate-500">{slider.help}</p>
          </div>
        );
      })}
      <div className="rounded-md bg-slate-50 px-3 py-2 text-xs text-slate-500">
        Rechazo global ({value.documentRejectGlobalScore.toFixed(2)}) se gestiona desde la
        configuración de la licencia y no es editable desde aquí.
      </div>
    </div>
  );
}
